import { addSubscriptionInterceptor } from "../../libs/helpers";

import { usersApi } from "./users/axios";
import { subscriptionApi } from "./subscription/axios";
import { planApi } from "./plan/axios";
import { supplierApi } from "./supplier/axios";
import { taskApi } from "./task/axios";
import { storageFileApi } from "./storage-file/axios";
import { profileApi } from "./profile/axios";
import { profileTaskApi } from "./profile-task/axios";
import { whatsappApi } from "./whatsapp/axios";
import { userStockifyApi } from "./user-stockify/axios";

export const setupAllInterceptors = () => {
  const instances = [
    usersApi,
    subscriptionApi,
    planApi,
    supplierApi,
    taskApi,
    storageFileApi,
    profileApi,
    profileTaskApi,
    whatsappApi,
    userStockifyApi,
  ];

  instances.forEach(addSubscriptionInterceptor);
};
